import React, { useState } from 'react';
import './conference-program.css';
import { FiPlus, FiMinus } from 'react-icons/fi';
import { Download } from 'lucide-react';


const ConferenceProgram = () => {
  const [expandedDay, setExpandedDay] = useState(null);
  const [expandedSession, setExpandedSession] = useState(null);

  const programData = [
{
  day: "SATURDAY 23rd January 2027",
  location: "Grand Hall",
sessions: [
  {
    time: "07:00 - 08:30",
    title: "Registration",
    description: "--"
  },

  {
    time: "08:30 - 09:00",
    title: "Opening Ceremony",
    description: `
    • 08:30am – Chief Guest Arrival
    • 08:35am – Ceremonial Procession
    • 08:40am – National Anthem
    • 08:45am – Lighting of Oil Lamp
    • 08:50am – Code of Ethics
    • 08:55am – Welcome Address
    
    M. A. Dhammika Deshapriya
    Chairman of Eye Care Group
    `
  },

  {
    time: "09:00 - 09:20",
    title: "Keynote & Special Guest Session",
    description: `
    Keynote Speaker Introduction – Sujanima Wijetunga

    Keynote Speaker –
    Dr. Kusum Rathnayake
    Past President,
    College of Ophthalmologists of Sri Lanka
    `
  },

  {
    time: "09:20 - 09:30",
    title: "Eye Care 2026 Highlights",
    description: `
    Naresh Pradhan
    Programme Director of Eye Care
    `
  },

  {
    time: "09:30 - 09:35",
    title: "Special Guest Speech",
    description: `
    Hon. Vraîe Cally Balthazaar
    Mayor of Colombo
    `
  },

  {
    time: "09:35 - 09:40",
    title: "Guest of Honor Speech",
    description: `
    Dr. Rajeev Prasad
    President Elect of World Council of Optometry (WCO)
    President of Asia Pacific Council of Optometry (APCO)
    `
  },

  {
    time: "09:40 - 09:45",
    title: "Special Guest Speech",
    description: `
    Dr. K. A. Lalithadheera
    Director General of TVEC
    `
  },

  {
    time: "09:45 - 09:50",
    title: "Special Guest Speech",
    description: `
    Jayantha Gallahewa
    President of Organisation of Professional Association (OPA) of Sri Lanka

    `
  },

  {
    time: "09:50 - 10:00",
    title: "Chief Guest Speech",
    description: `
    Hon. (Dr.) Hansaka Wijemuni 
    Deputy Minister of Health, Sri Lanka
    `
  },

  {
    time: "10:00 - 10:30",
    title: "Tea Break",
    description: "Refreshments"
  },

  {
    time: "10:30 - 10:50",
    title: "Symposium – Children & Binocular Vision",
    description: `
    Session Chairpersons:
    Nishamani Peiris
    Mahanama Priyantha

  
    Keynote Topic:
    Managing the Eyes in Children with Special Needs

    Keynote Speaker Introduction
    Introduction by:
    Nethushi N Pradhan

    Keynote Speaker:
    Dr. Amila De Alwis
    `
  },

  {
    time: "10:50 - 11:50",
    title: "Scientific Sessions – Binocular Vision",
    description: `
    1. Snr. Ortho. J. U. Seekubadu
       – Updates on Binocular Vision

    2. Dr. Raju Kaiti
       – Non-Strabismic Binocular Vision Anomalies (NSBVA)

    3. Thusil Gunawardana
       – Role of Hypermetropic Correction in Esotropia

    4. Dr. Vasumathy Vedantham
       – Retinopathy of Prematurity: Braving the Storm

    5. M. N. Uddin
       – Success Rate & Binocularity of Horizontal Strabismus Surgery in Adults

    Session Chairpersons:
    Erandi Siriwardhane
    Himidira Bopearachchi
    `
  },

  {
    time: "11:50 - 12:10",
    title: "Keynote Session",
    description: `
    Keynote Speaker Introduction –   Dilrukshi Gamage

    Topic:
    What Eyes Look For

    Keynote Speaker:
    Dr. Ayasmantha Peiris
    `
  },

  {
    time: "12:10 - 12:30",
    title: "Academic Collaboration Session",
    description: `
    Possible collaborations in Postgraduate
    Optometric Programmes within Asia

    Speaker:
    Prof. Azrin Esmady Ariffin
    `
  },

  {
    time: "12:30 - 13:30",
    title: "Panel Discussion",
    description: `
    Theme:
    The Future of Optometry Education 

    Panelists:
    • Prof. Azrin Esmady Ariffin
    • Prof. Adithya Goyal
    • Prof. Mohd Zaki Awg Isa
    • Prof. Kovin Naidoo

    Moderator:
    Naresh Pradhan
    `
  },

  {
    time: "13:30 - 14:30",
    title: "Lunch Break",
    description: "Lunch & Networking"
  },
    {
      time: "16:30 - 17:00",
      title: "TEA BREAK",
      description: "Evening Tea Break"
    }
  ],

  // ---------------------------------------------------
  // ALL WORKSHOPS HERE (Hall A & Hall B)
  // ---------------------------------------------------
  concurrentSessions: [
  // Hall A Workshops
  {
    location: "Hall A",
    time: "14:30 - 16:30",
    title: "Workshop – Myopia Management",
    description: "Conducted by: Yeshwanth Saoji & Lakshmi Shinde"
  },
  {
    location: "Hall A",
    time: "17:00 - 18:30",
    title: "Workshop – Neuro Optometry & Vision Therapy",
    description: "Conducted by: Dr. Rajeev Prasad & Dr. Cathy Stern"
  },

  // Hall B Workshops
  {
    location: "Hall B",
    time: "14:30 - 16:30",
    title: "Workshop – Low Vision",
    description: "Conducted by: Dr. Rajeev Prasad, Dr. Cathy Stern & Thusil T. Gunawardana"
  },
  {
    location: "Hall B",
    time: "17:00 - 18:30",
    title: "Workshop – Binocular Vision",
    description: "Conducted by: Prof. Adithya Goyal & Snr. Ortho. J. U. Seekubadu"
  }
]

},


{
  day: "SUNDAY 24th January 2027",
  location: "Grand Hall",
  sessions: [

    {
      time: "07:30 - 08:30",
      title: "Registration",
      description: "Participant registration"
    },

    {
      time: "08:30 - 08:40",
      title: "Welcome Speech",
      description: `
      Nishamani Peiris

      Session Chairpersons:
      J. U. Seekkubaadu
      Saumya Thilakarathne
      `
    },

    {
      time: "08:40 - 09:00",
      title: "Keynote Speaker Introduction & Keynote Session",
      description: `
      Topic: The Red Eye

      Keynote Speaker:
      N. Arul Kumar

      Introduced by:
      Dr. M. Kumaradas
      `
    },

    {
      time: "09:00 - 10:30",
      title: "Scientific Presentations",
      description: `
      • Amila Chandrasekara
        Microperimetry-Guided PRL Training for Low Vision Rehabilitation:
        Functional Insights and Clinical Outcomes

      • Irene S. Joseph
        Ocular Electrodiagnostic

      • Indira Madhavan
        Multidisciplinary Care: The Future of Low Vision

      • Dr. C. N. Nupearachchi
        Challenges of STEM Advocacy in Sri Lanka

      • Dr. M. Mizanur Rahman
        The Importance of AI-Based Fundus Photography in Optometry Practice

      • Lilendra Perera
        Parental Perception on Contact Lens

      • Alemán-González-Duhart D
        Diagnostic Potential of Tear Film Biomarkers in Diabetic Neuropathy
        and Their Modulation by Topical Insulin

      • Prof. Adithya Goyal
        Optometry Career Insight
      `
    },

    {
      time: "10:30 - 11:00",
      title: "Tea Break",
      description: `
      Refreshments

      Session Chairpersons:
      R. Sasikaran
      K. Dayalan
      `
    },

    {
      time: "11:00 - 11:40",
      title: "Panel Discussion – Public Eye Health",
      description: `
      Panelists:
      • Dr. Muthusamy Malaravan
      • Prof. Kovin Naidoo
      • Junu Shrestha
      • Dipak Sah

      Moderator:
      Naresh Pradhan
      `
    },

    {
      time: "11:40 - 12:20",
      title: "Plenary Presentation",
      description: `
      Topic:
      Eye Healthcare – What You Can Do to Achieve the Goal

      Speaker:
      Dr. Muthusamy Malaravan
      `
    },

    {
      time: "12:20 - 13:30",
      title: "Symposium – Community Eye Care",
      description: `
      • Prof. Kovin Naidoo
        Addressing the Refractive Error Challenge:
        An Opportunity Optometry Should Grasp

      • Sanjeeb Mishra
        Assessment of Baseline Knowledge, Attitudes, and Practices of
        Pediatric Myopia Management among Eye Care Professionals
        in Koshi Province of Nepal

      • Prof. M. Z. Awg Isa

      • Junu Shrestha
        Value of Vision: The Investment Case for Eye Health

      • Dipak Sah
        From Policy to People:
        Transforming Eye Health Through Community and
        National-Level Advocacy
      `
    },

    {
      time: "13:30 - 14:30",
      title: "Vote of Thanks & Lunch",
      description: `
      Vote of Thanks:
      Erandi Siriwardhane

      Followed by Lunch
      `
    },

    {
      time: "16:30 - 17:00",
      title: "Tea Break",
      description: "Evening tea break"
    }
  ],

  // ----------------- CONCURRENT SESSIONS -----------------
  concurrentSessions: [
    {
      location: "Hall A",
      time: "14:30 - 16:30",
      title: "Workshop – Advanced Contact Lens",
      description: "Conducted by: Yeshwanth Saoji & Lakshmi Shinde"
    },
  ]
}

  ];

  const toggleDay = (dayIndex) => {
    if (expandedDay === dayIndex) {
      setExpandedDay(null);
      setExpandedSession(null);
    } else {
      setExpandedDay(dayIndex);
      setExpandedSession(null);
    }
  };

  const toggleSession = (sessionIndex) => {
    if (expandedSession === sessionIndex) {
      setExpandedSession(null);
    } else {
      setExpandedSession(sessionIndex);
    }
  };

  return (
    <div className="conference-program">
      <div className="program-header">
        <h1>Conference Program</h1>
        <p>Our clinical program is regularly updated with the latest information. Check back for the next up-to-date details.</p>
      </div>

      <div className="who-can-join-container">
  <h1>Who Can Join?</h1>
  <ul>
    <li> Optometrist</li> 
    <li>Optician</li> 
    <li>Orthoptics</li> 
    <li>Ophthalmologist</li> 
    <li>General Physician</li> 
    <li>Family Medicine Consultant</li> 
    <li>Ophthalmology Residence</li> 
    <li>Nurse</li> 
    <li>Allied Health Professionals</li> 
    <li>Optometry Students</li> 
    <li>Industry Delegates</li> 
    <li>Researchers & Policy Makers</li> 
  </ul>                                                                                                                                                                                                           
</div>
{/* 
<br /><br /> */}

    {/* <a 
      href="/main-broucher.pdf" 
      download
      className="download-btn"
    >
      <Download size={18} />
      Download EYE CARE 2026 Booklet
    </a>



    <a 
      href="/EYECARE-TRI-FOLD.pdf" 
      download
      className="download-btn"
    >
      <Download size={18} />
      Download EYE CARE 2026 Mini Brochure
    </a> */}


<br /><br />


      <div className="program-days">
        {programData.map((dayData, dayIndex) => (
          <div key={dayIndex} className={`day-container ${expandedDay === dayIndex ? 'expanded' : ''}`}>
            <div className="day-header" onClick={() => toggleDay(dayIndex)}>
              <h2>{dayData.day}</h2>
              <span className="toggle-icon">
                {expandedDay === dayIndex ? <FiMinus /> : <FiPlus />}
              </span>
            </div>

            {expandedDay === dayIndex && (
              <div className="day-content">
               <div className="main-sessions">
  <h3>{dayData.location}</h3>
  <div className="sessions-list">
    {dayData.sessions.map((session, sessionIndex) => (
      <div key={sessionIndex} className="session-item">
        <div
          className="session-header"
          onClick={() => toggleSession(sessionIndex)}
        >
          <span className="session-time">{session.time}</span>
          <span className="session-title">{session.title}</span>
          <span className="session-toggle">
            {expandedSession === sessionIndex ? <FiMinus /> : <FiPlus />}
          </span>
        </div>

        {expandedSession === sessionIndex && (
          <div className="session-details">
            {session.description
              .trim()
              .split("\n")
              .map((line, i) => (
                <p key={i}>{line.trim()}</p>
              ))}
          </div>
        )}
      </div>
    ))}
  </div>
</div>


                <div className="concurrent-sessions">
                  <h3>Hall A & B Sessions</h3>
                  <p>Experience a full day of insightful sessions with concurrent sessions running throughout the event.</p>
                  <div className="concurrent-list">
                    {dayData.concurrentSessions.map((session, sessionIndex) => (
                      <div key={sessionIndex} className="session-item">
                        <div className="session-header" onClick={() => toggleSession(dayData.sessions.length + sessionIndex)}>
                          <span className="session-location">{session.location}</span>
                          <span className="session-time">{session.time}</span>
                          <span className="session-title">{session.title}</span>
                          <span className="session-toggle">
                            {expandedSession === dayData.sessions.length + sessionIndex ? <FiMinus /> : <FiPlus />}
                          </span>
                        </div>
                        {expandedSession === dayData.sessions.length + sessionIndex && (
                          <div className="session-details">
                            <p>{session.description}</p>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>






              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ConferenceProgram;